import React, { useState, useEffect } from "react";
import Loading from "../misc/Loading";
import StatusPage from "../layout/StatusPage";
import { useAptApi } from "../../hooks/UseAptApi";
import { useAsyncError } from "../../hooks/useAsyncError";
import { ErrorModal } from "../errors/ErrorModal";

export const GetDocuments = ({ engagmentId, projectCode, projectName }) => {
  const [responseData, setresponseData] = useState();
  const [error, setError] = useState(null);
  const { CopyDocuments } = useAptApi();  
  const throwError = useAsyncError();

  useEffect(() => {
    async function GetDocumentsByEngagementId() {
      try {
        let response = await CopyDocuments(engagmentId, { projectCode, projectName });        
        if (response.isSuccess) {
          setresponseData(response.data);
        } else {
          setError(response.data || 'An error occurred while copying documents');
        }
      } catch (ex) {
        throwError(ex);
      }
    }
    GetDocumentsByEngagementId();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      {responseData ? (
        <StatusPage
          // @ts-ignore
          status={responseData.response.success}
          // @ts-ignore
          message={responseData.response.message}
        />
      ) : (
        <Loading text="Getting Documents" />
      )}
      {error && <ErrorModal title="Max Requests Reached" message={error} show={true} onHide={() => {
        window.location.reload();
        setError(null);
      }} />}
    </div>
  );
};
